export default {"src":"/_next/static/media/logo.ac52737d.svg","height":171,"width":744,"blurWidth":0,"blurHeight":0};